// WB-M1B S6 (doc 23 §29) -- the board's saved VIEW on another screen.
//
// A board is saved with the view it was left in (scroll and zoom), and opens
// in it again. On a narrower screen -- a board written on a desktop, opened
// on a phone -- that view can show none of what is on the board: the board
// looks empty and is not. Only that case is decided here: whether ANYTHING of
// the board is inside the visible board. If nothing is, the editor brings the
// content into view when it opens (its existing "reset view"); every other
// saved view is kept exactly as it was left.
//
// View only: nothing here reads or changes what is saved of an element.

// The upright box an element surely lies in: its own box, or -- turned --
// the circle around its centre that the turned box cannot leave.
function reach(element) {
  const width = Math.abs(element.width) || 0
  const height = Math.abs(element.height) || 0
  const x = Math.min(element.x, element.x + (element.width || 0))
  const y = Math.min(element.y, element.y + (element.height || 0))
  if (!element.angle) return { x, y, width, height }
  const radius = Math.hypot(width, height) / 2
  const centre = { x: x + width / 2, y: y + height / 2 }
  return {
    x: centre.x - radius,
    y: centre.y - radius,
    width: radius * 2,
    height: radius * 2,
  }
}

function isBox(box) {
  return (
    !!box &&
    [box.x, box.y, box.width, box.height].every(Number.isFinite) &&
    box.width > 0 &&
    box.height > 0
  )
}

/**
 * Whether the saved view should be replaced by "the content in view": the
 * board has something on it and none of it reaches into the visible board.
 * An empty board, a board of which any part shows, and a view that cannot be
 * measured yet all keep the saved view.
 * @param {object[]} elements -- the live elements of the scene
 * @param {{x: number, y: number, width: number, height: number}} visible --
 *   the visible board in scene coordinates
 * @returns {boolean}
 */
export function isBoardContentOutOfView(elements, visible) {
  if (!isBox(visible)) return false
  const live = (elements || []).filter(
    element =>
      !!element &&
      !element.isDeleted &&
      Number.isFinite(element.x) &&
      Number.isFinite(element.y)
  )
  if (live.length === 0) return false
  return !live.some(element => {
    const box = reach(element)
    return (
      box.x <= visible.x + visible.width &&
      box.x + box.width >= visible.x &&
      box.y <= visible.y + visible.height &&
      box.y + box.height >= visible.y
    )
  })
}
